"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudioFileTypeToJSON = exports.AudioFileTypeFromJSONTyped = exports.AudioFileTypeFromJSON = exports.AudioFileType = void 0;
/**
 * The file type of the audio asset as defined by the 'file type' specification of the ISO base media file format standard.
 * @export
 */
exports.AudioFileType = {
    Mp3: 'MP3',
    Ogg: 'OGG',
    Wav: 'WAV'
};
function AudioFileTypeFromJSON(json) {
    return AudioFileTypeFromJSONTyped(json, false);
}
exports.AudioFileTypeFromJSON = AudioFileTypeFromJSON;
function AudioFileTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.AudioFileTypeFromJSONTyped = AudioFileTypeFromJSONTyped;
function AudioFileTypeToJSON(value) {
    return value;
}
exports.AudioFileTypeToJSON = AudioFileTypeToJSON;
